import React from 'react'
import { StoreIcon } from '@sainsburys-tech/bolt-icons'
import * as Styled from './CollectionBox.styles'

export const CollectionTitle = ({ collectable }) => {
  return (
    collectable && (
      <Styled.FulfilmentCollectionHeader data-test='fulfilment-collection-header'>
        <StoreIcon width={24} height={24} />
        <Styled.FulfilmentCollectionTitle data-test='fulfilment-collection-title'>
          Click & Collect
        </Styled.FulfilmentCollectionTitle>
      </Styled.FulfilmentCollectionHeader>
    )
  )
}
